import { ref, computed } from 'vue'
import { useLanguage } from './useLanguage.js'
import configService from '&/services/configService.js'

// Estado global reactivo para configuración
const config = ref(null)

export function useConfig() {
    const { language } = useLanguage()

    // Computed que devuelve una función para obtener textos localizados
    const getConfigText = computed(() => {
        return (fieldName, fallbackText = '') => {
            // console.log(`[useConfig] getConfigText called for field: ${fieldName} with fallback: "${fallbackText}"`)
            if (!config.value) {
                loadConfiguration();
                return fallbackText;
            }

            // Navegar por la estructura de secciones (ej: cookies.bannerMessage)
            const parts = fieldName.split('.')
            let value = config.value

            for (const part of parts) {
                if (value && typeof value === 'object') {
                    value = value[part]
                } else {
                    value = null
                    break
                }
            }

            // Si encontramos el objeto de idioma, usamos el idioma seleccionado con fallback a español
            if (value && typeof value === 'object') {
             //   console.log(`[useConfig] Found localized value for field: ${fieldName}`, value[language.value])
                return value[language.value] || value.es || fallbackText
            }

           // console.log(`[useConfig] No localized value found for field: ${fieldName}, returning fallback: "${fallbackText}"`)
            return fallbackText
        }
    })

    const getGlobalConfig = computed(() => {
        return (fieldName, fallbackValue = null) => {
            if (!config.value) {
                loadConfiguration();
                return fallbackValue;
            }

            const value = config.value.globalConfig[fieldName];

            return value || fallbackValue
        }
    })

    async function loadConfiguration() {
        try {
            config.value = await configService.getConfig()
           // console.log('[useConfig] Configuración cargada:', config.value)
        } catch (error) {
            console.warn('⚠️ [useConfig] Error cargando configuración:', error)
            config.value = {}
        }
    }

    return {
        getConfigText,
        getGlobalConfig,
    }
}